import Link from '@/components/Common/Nav/Link/Link';
import {
  GET_DIRECTION,
  GET_SPACING,
  GET_WRAPPER_STYLES,
  PROPS,
} from '@/components/Common/Nav/Nav.utils';
import { Stack } from '@mui/material';
import Box from '@mui/material/Box';

/*
Tech debt.
This nav, should be used only for sidebar menu.
Move this inside the SideNav folder once it is achieved
Also, simplify the model as, horizontal prop would probably not be required
*/
export default function Nav({
  links,
  collapse = false,
  horizontal = false,
  sx,
}: PROPS) {
  return (
    <Box sx={{ ...GET_WRAPPER_STYLES(horizontal), ...sx }}>
      <Stack
        direction={GET_DIRECTION(horizontal)}
        spacing={GET_SPACING(horizontal)}
      >
        {links.map((link) => (
          <Link
            key={link?.label}
            to={link?.to}
            icon={link?.icon}
            label={link?.label}
            collapse={collapse}
            horizontal={horizontal}
            end={link?.end}
          />
        ))}
      </Stack>
    </Box>
  );
}
